export const LOADING = "loading";
export const ERROR = "error";
export const SUCCESS = "success";
export const IDLE = "idle";
export const ACTIVE = "active";
export const UNSAVED = "unsaved";
export const SAVED = "saved";
export const CONFIRMED = "confirmed";
